export function cashTransferAmount(value) {
  const text = String(value ?? '').trim().replace(',', '.');
  if (!/^\d+(?:\.\d{1,2})?$/.test(text)) return null;
  const [whole, fraction = ''] = text.split('.');
  const amount = `${whole.replace(/^0+(?=\d)/, '')}.${fraction.padEnd(2, '0')}`;
  return amount === '0.00' ? null : amount;
}

export function cashTransferAccounts(accounts, userId, currency = 'EUR') {
  return accounts.filter(account => Number(account.user_id) === Number(userId) && account.is_active === true &&
    (currency === null || account.currency === currency) && ['checking', 'savings', 'deposit', 'cash'].includes(account.account_type) &&
    account.latest_balance?.amount != null);
}
